import React, { useState } from 'react'
import { createFullName, showToast } from '../../../utils';
import { DateUtils } from '../../../utils/dateUtils';
import NoData from '../../../global/ui/NoData';
import DraggableItem from '../../../global/DraggableItem';

const img = 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=280&fit=crop'

const LocationVaultListView = (props: any) => {

    const [openMenuId, setOpenMenuId] = useState<number | null>(null);

    const allData = props?.allLocationData?.length > 0 ? props?.allLocationData : [];

    if (allData?.length <= 0) {
        return (
            <NoData message='No location information available.' />
        )
    }

    return (
        <div className="lv-table-wrap">
            <table className="lv-table">
                <thead>
                    <tr className="lv-table__head-row">
                        {/* <th className="lv-table__th lv-table__th--check">
                            <input
                                type="checkbox"
                                className="lv-checkbox"
                                checked={false}
                                onChange={emptyFunction}
                            />
                        </th> */}
                        <th className="lv-table__th lv-table__th--thumb" />
                        <th className="lv-table__th">Location name</th>
                        <th className="lv-table__th">Location</th>
                        <th className="lv-table__th">Scouted by</th>
                        <th className="lv-table__th">Shoot rate</th>
                        <th className="lv-table__th">Date added</th>
                        <th className="lv-table__th">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {allData?.map((item: any, index: any) => {
                        const loc = item?.location;
                        return (
                            <DraggableItem
                                onClick={() => {
                                    if (openMenuId) {
                                        setOpenMenuId(null)
                                        return
                                    }
                                }}
                                key={loc?.id}
                                className="lv-table__row"
                                index={index}
                                moveItem={props?.moveItem}
                                containerTag={'tr'}
                                itemId={loc?.id}
                                renderType='vault'
                                data={item}

                            >
                                {/* <td className="lv-table__td lv-table__td--check">
                                <input
                                    type="checkbox"
                                    className="lv-checkbox"
                                    checked={false}
                                    onChange={emptyFunction}
                                />
                            </td> */}
                                <td
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        props?.onImageView?.(item);
                                        if (openMenuId) {
                                            setOpenMenuId(null)
                                            return
                                        }
                                    }}
                                    className="lv-table__td lv-table__td--thumb"
                                >
                                    <img src={loc?.thumbnail || '/assets/images/yellow-6th.png'} alt={loc?.name} className="lv-table__thumb" />
                                </td>
                                <td onClick={() => {
                                    props?.onView?.(item);
                                    if (openMenuId) {
                                        setOpenMenuId(null)
                                        return
                                    }
                                }}
                                    className="lv-table__td lv-table__td--name"
                                >
                                    {loc?.name}
                                </td>
                                <td className="lv-table__td">{loc?.address}</td>
                                <td className="lv-table__td">{createFullName(loc?.created_by?.first_name, loc?.created_by?.last_name,)}</td>
                                <td className="lv-table__td">{loc?.shoot_rate}</td>
                                <td className="lv-table__td">{`${loc?.date_scouted ? DateUtils.formatDateTime(loc?.date_scouted, 'DD/MM/YYYY') : ''}`}</td>
                                {item?.role != 'V' &&
                                    <td className="lv-table__td">
                                        <div className="lv-card__menu-wrap">
                                            <button
                                                className="lv-card__menu-btn"
                                                onClick={e => {
                                                    e.stopPropagation();
                                                    setOpenMenuId(openMenuId === loc.id ? null : loc.id);
                                                }}
                                            >
                                                <img src='/assets/images/three-dots-more.svg' alt='more' />
                                            </button>
                                            {openMenuId === loc.id && (
                                                <div className="lv-card__menu-dropdown">
                                                    {!props?.hideAsign &&
                                                        <>
                                                            <button
                                                                onClick={() => {
                                                                    setOpenMenuId(null)
                                                                    props?.onAsign(item)
                                                                }}
                                                                className="lv-card__menu-item">
                                                                <img src='/assets/images/plus-icon-1.svg' />
                                                                {props?.vaultType == 'myvault' ? 'Add to production' : 'Assign Location'}
                                                            </button>
                                                            {props?.vaultType != 'myvault' &&
                                                                <button
                                                                    onClick={() => {
                                                                        setOpenMenuId(null)
                                                                        props?.onScriptAsign(item)
                                                                    }}
                                                                    className="lv-card__menu-item">
                                                                    <img src='/assets/images/perscript-active.svg' />
                                                                    Assign to script
                                                                </button>
                                                            }
                                                        </>
                                                    }
                                                    {props?.vaultType == 'myvault'
                                                        ?
                                                        null
                                                        :
                                                        <button
                                                            onClick={() => {
                                                                setOpenMenuId(null)
                                                                props?.onShare?.(item)
                                                            }}
                                                            className="lv-card__menu-item"
                                                        >
                                                            <img src='/assets/images/share-blue.svg' />
                                                            Share
                                                        </button>
                                                    }
                                                    <button
                                                        className="lv-card__menu-item"
                                                        onClick={() => {
                                                            props?.onDelete(item)
                                                            setOpenMenuId(null)
                                                        }}
                                                    >
                                                        <img src='/assets/images/Delete-icon-red.svg' />
                                                        Delete
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                }
                            </DraggableItem>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default LocationVaultListView